import { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'
import { Spinner } from '@/components/Spinner'
import { analyticsPathOnly, trackEvent } from '@/lib/analytics'
import { consumePostLoginRedirect } from '@/lib/postLoginRedirect'

/** Magic-link landing page: completes login with the emailToken from the URL. */
export function CompleteAuthPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const completeWithEmailToken = useAuthStore((s) => s.completeWithEmailToken)
  const [error, setError] = useState('')
  const startedRef = useRef(false)

  useEffect(() => {
    if (startedRef.current) return
    startedRef.current = true
    const emailToken = searchParams.get('emailToken')
    if (!emailToken) {
      setError('Deze inloglink is ongeldig.')
      return
    }
    completeWithEmailToken(emailToken)
      .then(() => {
        // Back to where the login started, e.g. a program deep link.
        const target = consumePostLoginRedirect() ?? '/services'
        trackEvent('login_success', {
          method: 'email_link',
          redirect_path: analyticsPathOnly(target) ?? '/services',
        })
        navigate(target, { replace: true })
      })
      .catch(() => setError('Deze inloglink is verlopen of al gebruikt.'))
  }, [searchParams, completeWithEmailToken, navigate])

  return (
    <div className="flex min-h-[50vh] items-center justify-center px-4">
      <div className="card-beige w-full max-w-md p-8 text-center">
        {error ? (
          <>
            <h1 className="text-xl lg:text-26">Inloggen mislukt</h1>
            <p className="mt-2 text-base leading-normal text-dark-blue/60">{error}</p>
            <Link to="/login" className="btn-primary mt-6 inline-flex">
              Opnieuw inloggen
            </Link>
          </>
        ) : (
          <>
            <div className="flex justify-center">
              <Spinner />
            </div>
            <h1 className="mt-4 text-xl lg:text-26">Je wordt ingelogd…</h1>
            <p className="mt-2 text-base text-dark-blue/60">Een moment geduld.</p>
          </>
        )}
      </div>
    </div>
  )
}
